module.exports = __webpack_public_path__ + "static/img/icon-mp4.5cb44c06.png";